import { css } from '@emotion/react';
import tw from 'twin.macro';

const buttonStyles = {
  buttonWrapper: css`
    display: inline-block;
    ${tw`font-body`}
  `,
  buttonGroup: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    padding: 0.25rem 0.5rem;
    float: left;
    &:hover {
      cursor: pointer;
      background: #666;
      button {
        background: #666;
      }
    }
    button {
      margin: 0 auto;
    }
    span {
      color: #ddd;
      line-height: 1.425rem;
    }
  `,
  button: css`
    background: #333;
    color: #ddd;
    font-size: 18px;
    border: 0;
    vertical-align: bottom;
    height: 34px;
    width: 36px;
    @media screen and (min-width: 1024px) {
      &:hover,
      &:focus {
        background: #666;
        outline: 0;
      }
    }
    svg {
      color: #ddd;
      fill: #ddd;
      margin: 0 auto;
    }
  `,
  active: css`
    background: #666;
    color: #ddd;
    svg {
      fill: #ddd;
    }
  `,
  separator: css`
    display: inline-block;
    border-right: 1px solid #ddd;
    height: 24px;
    margin: 0 0.5em;
  `,
};

const inlineToolbarStyles = {
  toolbar: css`
    left: 50%;
    transform: translate(-50%) scale(0);
    position: absolute;
    border: 1px solid #111;
    background: #333;
    border-radius: 4px;
    box-shadow: 0px 1px 3px 0px rgba(220, 220, 220, 1);
    z-index: 100;
    box-sizing: border-box;
    line-height: 1 !important;
    display: flex;
    &:after,
    &:before {
      top: 100%;
      left: 50%;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }
    &:after {
      border-color: rgba(255, 255, 255, 0);
      border-top-color: #333;
      border-width: 4px;
      margin-left: -4px;
    }
    &:before {
      border-color: rgba(255, 255, 255, 0);
      border-top-color: #111;
      border-width: 6px;
      margin-left: -6px;
    }
    input[type='text'] {
      color: #ddd;
      height: 34px;
      width: 245px;
      padding: 0 12px;
      font-size: 15px;
      font-family: inherit;
      background-color: #333;
      border: none;
      color: #ddd;
      &:focus {
        outline: none;
      }
      &::placeholder {
        color: #a4a4a4;
      }
      &::-moz-selection {
        color: #fff;
        background-color: #3297fd;
      }
      &::selection {
        color: #fff;
        background-color: #3297fd;
      }
    }
  `,
};

const blockTypeSelectStyles = {
  blockType: css`
    box-sizing: border-box;
    border: 1px solid #111;
    background: #333;
    padding: 5px;
    margin: 0;
    border-radius: 18px;
    cursor: pointer;
    height: 36px;
    width: 36px;
    line-height: 36px;
    text-align: center;
    svg {
      fill: #ddd;
    }
  `,

  spacer: css`
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    width: 74px;
    height: 8px;
  `,

  popup: css`
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    background: #efefef;
    border: 1px solid #111;
    background: #333;
    border-radius: 4px;
    box-shadow: 0px 1px 3px 0px rgba(220, 220, 220, 1);
    z-index: 3;
    box-sizing: border-box;
    width: 74px;
    margin-top: 8px;
    &:after,
    &:before {
      bottom: 100%;
      left: 50%;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }
    &:after {
      border-color: rgba(255, 255, 255, 0);
      border-bottom-color: #333;
      border-width: 4px;
      margin-left: -4px;
    }
    &:before {
      border-color: rgba(255, 255, 255, 0);
      border-bottom-color: #111;
      border-width: 6px;
      margin-left: -6px;
    }
  `,
};

const sideToolbarStyles = {
  wrapper: css`
    position: absolute;
    z-index: 100;
  `,
};

export const EditorTheme = {
  buttonStyles,
  inlineToolbarStyles,
  blockTypeSelectStyles,
  sideToolbarStyles,
};
